import { render } from "./PredictLife.vue?vue&type=template&id=1adf5886&scoped=true"
import script from "./PredictLife.vue?vue&type=script&lang=js"
export * from "./PredictLife.vue?vue&type=script&lang=js"

import "./PredictLife.vue?vue&type=style&index=0&id=1adf5886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adf5886"]])

export default __exports__